import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { SlaAdherence } from '@Models';
import { SharedModule } from '@Shared/shared.module';
import { ChartModule } from 'primeng/chart';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'case-sla-adherence-chart',
    templateUrl: './case-sla-adherence-chart.component.html',
    styleUrl: './case-sla-adherence-chart.component.scss',
    imports: [SharedModule, ChartModule, ProgressBarModule, ToastModule]
})
export class CaseSlaAdherenceChartComponent implements OnChanges {
    @Input() slaAdherenceData: SlaAdherence[] = [];
    @Input() isExpanded = false;
    @Input() showSlaInHours = true;

    targetSLA: number = 95;

    chartData = {
        datasets: [
            {
                data: [0, 100],
                backgroundColor: ['#4caf50', '#D7D7D7'],
                borderWidth: 0,
                hoverOffset: 0
            }
        ]
    };

    chartOptions = {
        cutout: '88%',
        plugins: {
            legend: { display: false },
            tooltip: { enabled: false }
        }
    };

    chartPlugins = [{
        id: 'centerText',
        afterDraw: (chart: any) => {
            const { ctx, chartArea: { top, left, width, height } } = chart;
            ctx.save();

            const centerX = left + width / 2;
            const centerY = top + height / 2;
            
            const text = chart.data.datasets[0].data[0] + '%';
            ctx.font = `bold 16px Roboto`;
            ctx.textBaseline = 'bottom';
            ctx.textAlign = 'center';
            ctx.fillStyle = '#000000';
            ctx.fillText(text, centerX, centerY + 5);

            ctx.font = '12px Roboto';
            ctx.fillStyle = '#00000099';
            ctx.textBaseline = 'top';
            ctx.fillText('Avg SLA', centerX, centerY + 10);

            ctx.restore();
        }
    }];

    ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges['slaAdherenceData']) {
            let averageSLA = 0;
            if (this.slaAdherenceData?.length) {
                const rawAverage = this.slaAdherenceData.reduce((sum, item) => sum + item.slaAdherencePercentage, 0) / this.slaAdherenceData.length;
                averageSLA = Math.round(rawAverage * 10) / 10;
            }
            this.chartData = {
                ...this.chartData,
                datasets: [{
                    ...this.chartData.datasets[0],
                    data: [averageSLA, 100 - averageSLA],
                    backgroundColor: averageSLA >= this.targetSLA ? ['#1D8F0B', '#D7D7D7'] : ['#900606', '#D7D7D7']
                }]
            };
        }
    }

    floorPercentage(value: number): number {
        return Math.floor(value);
    }

    getSlaItemTooltip(item: SlaAdherence): string {
        if (this.showSlaInHours) {
            return `${item.queueName} (${item.slaInHours}hr): ${item.slaAdherencePercentage.toFixed(1)}%`;
        }

        return `${item.queueName}: ${item.slaAdherencePercentage.toFixed(1)}%`;
    }
}
